import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import axios from 'axios';
import { baseURL } from '../../constants/const'; 
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import Sidebar from '../Sidebar/Sidebar';
import { CssBaseline, Box } from '@mui/material';

const Layout = () => {
  const drawerWidth = 240; // Sidebar width
  const appBarHeight = 64; // Navbar height
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false); // State to toggle sidebar visibility
  const navigate = useNavigate();
/*
  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      try {
        const formData = new URLSearchParams();
        formData.append('accessToken', accessToken);
        const response = await axios.post(CHECK_AUTH_ENDPOINT, formData, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        const isValid = response.data.isValid;
        setIsLoggedIn(isValid);

        if (!isValid) {
          handleLogout();
        }
      } catch (error) {
        // Handle error
      }
    } else {
      navigate('/login');
    }
  };*/

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    setIsLoggedIn(false);
    navigate('/login');
  };

  // Function to toggle sidebar visibility
  const onToggleSidebar = () => {
    setSidebarOpen((prevOpen) => !prevOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <Navbar isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} onToggleSidebar={onToggleSidebar} />
      <Sidebar drawerWidth={drawerWidth} appBarHeight={appBarHeight} isOpen={sidebarOpen} />
      
      {/* Main content adjusted based on sidebar state */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          mt: `${appBarHeight}px`,
          ml: sidebarOpen ? `${drawerWidth}px` : 0, // Shift content only if sidebar is open
          transition: 'margin-left 0.3s ease', // Smooth transition when opening/closing sidebar
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;

